import {Button, Col, Form, Table} from "react-bootstrap";
import {
    createContact,
    formatPhoneNumber,
    getClientContacts
} from "../../../../Services/ApiService";
import {useState} from "@hookstate/core";

function ContactsBlock(props) {
    const client = props.selectedClient;
    const contacts = useState(client.contacts);
    const jobValues = props.jobValues;

    const contactDivHidden = useState(true);

    const newContact = useState({
        clientId: client.get().id,
        email: '',
        name: '',
        phone: '',
    });

    function onBillingContactChanged(e) {
        if (e.target.value !== "-1") {
            const selectedContact = contacts.get().filter(contact => {
                return contact.id.toString() === e.target.value;
            })[0];

            jobValues.billingContactName.set(selectedContact.name);
            jobValues.billingContactPhone.set(selectedContact.phone);
            jobValues.billingContactEmail.set(selectedContact.email);
        } else {
            jobValues.billingContactName.set('');
            jobValues.billingContactPhone.set('');
            jobValues.billingContactEmail.set('');
        }
    }

    function onShippingContactChanged(e) {
        const contactId = (e.target.value);

        if (contactId !== "-1") {
            const selectedContact = contacts.get().filter(contact => {
                return contact.id.toString() === contactId;
            })[0];

            jobValues.shippingContactName.set(selectedContact.name);
            jobValues.shippingContactPhone.set(selectedContact.phone);
            jobValues.shippingContactEmail.set(selectedContact.email);
        } else {
            jobValues.shippingContactName.set('');
            jobValues.shippingContactPhone.set('');
            jobValues.shippingContactEmail.set('');
        }
    }

    function displayContacts() {
        return <div>
            <Table>
                <thead>
                <tr>
                    <th>Billing</th>
                    <th>Shipping</th>
                    <th>Contact</th>
                </tr>
                </thead>
                <tbody>
                {contacts.get().map((contact, idx) => {
                    return (
                        <tr key={idx}>
                            <td>
                                <Form.Check
                                    className={'addressSelectRadio col-1'}
                                    type={"radio"}
                                    name={'bContactSelect'}
                                    value={contact.id}
                                    onChange={onBillingContactChanged}
                                />
                            </td>
                            <td>
                                <Form.Check
                                    className={'addressSelectRadio col-1'}
                                    type={"radio"}
                                    name={'sContactSelect'}
                                    value={contact.id}
                                    onChange={onShippingContactChanged}
                                />
                            </td>
                            <td className={"col-10"}>
                                <Col id={'contactDetails'}>
                                    <span className={'contactSelectTitle'}>Name: </span>{contact.name}<br/>
                                    <span className={'contactSelectTitle'}>
                                        Phone: </span>{formatPhoneNumber(contact.phone)}<br/>
                                    <span className={'contactSelectTitle'}>Email: </span>{contact.email}
                                </Col>
                            </td>
                        </tr>
                    )
                })}
                <tr>
                    <td>
                        <Form.Check
                            className={'addressSelectRadio col-1'}
                            type={"radio"}
                            name={'bContactSelect'}
                            value={'-1'}
                            onChange={onBillingContactChanged}
                        />
                    </td>
                    <td>
                        <Form.Check
                            className={'addressSelectRadio col-1'}
                            type={"radio"}
                            name={'sContactSelect'}
                            value={-1}
                            onChange={onShippingContactChanged}
                        />
                    </td>
                    <td>None</td>
                </tr>
                </tbody>
            </Table>
        </div>
    }

    function toggleNewContactHidden() {
        contactDivHidden.set(!contactDivHidden.get());
        newContact.set({
            clientId: client.get().id,
            email: '',
            name: '',
            phone: '',
        })
    }

    function newContactForm() {
        return <Form>
            <h6>Add Contact</h6>
            <Form.Control id={`name`}
                          onChange={(e => newContact.name.set(e.target.value))}
                          value={newContact.get().name}
                          placeholder={'Name'}
            />
            <Form.Control id={`phone`}
                          onChange={(e => newContact.phone.set(e.target.value))}
                          value={formatPhoneNumber(newContact.get().phone)}
                          placeholder={'Phone'}
            />
            <Form.Control id={`email`}
                          onChange={(e => newContact.email.set(e.target.value))}
                          value={newContact.get().email}
                          placeholder={'Email'}
            />
        </Form>
    }

    function addNewContactDiv() {
        return <div id={'newContact'}>
            <div id={`newContactDiv_${contactDivHidden.get()}`}>
                {newContactForm()}
                <div className={'buttons'}>
                    <Button onClick={toggleNewContactHidden}>Cancel</Button>
                    <Button onClick={handleNewContactSave}>Save</Button>
                </div>
            </div>

            <Button id={`newContactDiv_${!contactDivHidden.get()}`} variant={"secondary"}
                    onClick={toggleNewContactHidden}>Add New Contact</Button>
        </div>
    }

    function handleNewContactSave() {
        createContact(newContact.get(), () => {
            setTimeout(_ => {
                getClientContacts(client.get().id, contacts => {
                    client.contacts.set(contacts);
                })
                toggleNewContactHidden();
            }, 50);
        });
    }


    return <div id={'contactsBlock'}>
        <h5>Contacts: </h5>
        {contacts.length !== 0 &&
            displayContacts()
        }
        {contacts.length < 1 &&
            <p>No contacts found.</p>
        }
        {addNewContactDiv()}
    </div>
}

export default ContactsBlock;